/**
 * Whether rich text HTML has any text other than whitespace.
 * An empty editor still produces markup such as <p><br></p>.
 */
const richTextHasText = (html: string): boolean => {
	const body = new DOMParser().parseFromString(html, "text/html").body
	return !!body.textContent?.trim()
}

export { richTextHasText }
